import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp';
import { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LoginOtpInput = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(OTPInput, {
    containerClassName: "otp-input",
    inputMode: "numeric",
    maxLength: 6,
    pattern: REGEXP_ONLY_DIGITS,
    ref: ref,
    render: ({
      slots
    }) => /*#__PURE__*/_jsx(SlotsContainer, {
      children: slots.map((slot, index) => /*#__PURE__*/_jsx(Slot, {
        ...slot
      }, index))
    }),
    ...props
  });
});
LoginOtpInput.displayName = 'LoginOtpInput';
const Slot = props => {
  return /*#__PURE__*/_jsxs(SlotInput, {
    $isActive: props.isActive,
    "data-sentry-element": "SlotInput",
    "data-sentry-component": "Slot",
    "data-sentry-source-file": "LoginOtpPopup.tsx",
    children: [props.char ?? props.placeholderChar, props.hasFakeCaret && /*#__PURE__*/_jsx(FakeCaret, {})]
  });
};
const SlotsContainer = styled.div.withConfig({
  displayName: "LoginOtpPopup__SlotsContainer"
})(["display:grid;gap:", ";grid-auto-flow:column;"], tombac.space(1));
const SlotInput = styled.div.withConfig({
  displayName: "LoginOtpPopup__SlotInput"
})(["align-items:center;border:", ";border-color:", ";border-radius:", ";display:flex;height:", ";justify-content:center;transition:0.1s ease-out;transition-property:border-color,background-color,color;width:", ";", " .otp-input:hover &{background-color:", ";}"], tombac.parse('1u solid'), ({
  $isActive
}) => $isActive ? tombac.color('accent') : tombac.color('neutral', 400), tombac.unit(7), tombac.space(6), tombac.space(5), tombac.altText({
  fontSize: 16,
  fontWeight: 'bold'
}), tombac.color('neutral', 200));
const blink = keyframes(["0%,100%{opacity:1;}50%{opacity:0;}"]);
const FakeCaret = styled.div.withConfig({
  displayName: "LoginOtpPopup__FakeCaret"
})(["animation:", " 1s step-end infinite;background-color:", ";height:", ";width:", ";"], blink, tombac.color.black, tombac.space(3), tombac.unit(1));